import Head from "next/head";
import Image from "next/image";
import NextLink from "next/link";
import PageLayout from "layouts/Page";
import {
  Box,
  SimpleGrid,
  Text,
  Heading,
  Button,
  Badge,
  Flex,
  Divider,
  Icon,
} from "@chakra-ui/react";
import { Truck } from "react-feather";

const PRODUCTS = [
  {
    slug: "flamme",
    name: "Flamme Tête en l'Air",
    description: "Flamme brodée de qualité supérieure. Format : 130mm x 30mm.",
    price: "7,99 €",
    priceId: "price_1TlYFnJKqyXVuWQ45rqNjsXo",
    image: "/images/shop/flamme.webp",
  },
  {
    slug: "sticker",
    name: "Sticker Tête en l'Air",
    description:
      "Sticker rond en vinyle épais et résistant. Protégé contre les rayures, la pluie et le soleil. Format : 75mm x 75mm.",
    price: "1,99 €",
    priceId: "price_1TlYGcJKqyXVuWQ4or36ZFgw",
    image: "/images/shop/sticker.webp",
  },
  {
    slug: "bundle-1",
    name: "Bundle N°1",
    description:
      "1 flamme + 2 stickers. Format flamme : 130mm x 30mm. Format sticker : 75mm x 75mm.",
    price: "8,99 €",
    priceId: "price_1TlYHVJKqyXVuWQ4fFcc0lC5",
    image: "/images/shop/bundle1.webp",
  },
  {
    slug: "bundle-2",
    name: "Bundle N°2",
    description:
      "2 flammes + 4 stickers. Format flamme : 130mm x 30mm. Format sticker : 75mm x 75mm.",
    price: "15,99 €",
    priceId: "price_1TlYIKJKqyXVuWQ4eJS0EF9Y",
    image: "/images/shop/bundle2.webp",
  },
  {
    slug: "bundle-3",
    name: "Bundle N°3",
    description:
      "3 flammes + 3 stickers. Format flamme : 130mm x 30mm. Format sticker : 75mm x 75mm.",
    price: "24,99 €",
    priceId: "price_1TlYIqJKqyXVuWQ4xLIX24rl",
    image: "/images/shop/bundle3.webp",
  },
];

function ProductCard({ product }) {
  return (
    <NextLink href={`/shop/${product.slug}`} passHref>
    <Box
      as="a"
      bg="white"
      borderRadius="xl"
      overflow="hidden"
      boxShadow="xl"
      _hover={{ boxShadow: "2xl", transform: "translateY(-3px)" }}
      transition="all 0.2s"
      display="flex"
      flexDirection="column"
      cursor="pointer"
    >
      <Box position="relative" w="100%" h="280px" bg="gray.100">
        <Image
          src={product.image}
          alt={product.name}
          layout="fill"
          objectFit="cover"
        />
        {product.badge && (
          <Badge
            position="absolute"
            top={3}
            right={3}
            colorScheme="brand"
            px={2}
            py={1}
            borderRadius="md"
            fontSize="xs"
          >
            {product.badge}
          </Badge>
        )}
      </Box>

      <Flex direction="column" flex="1" p={5}>
        <Heading
          fontSize="lg"
          mb={2}
          color="secondary.main"
        >
          {product.name}
        </Heading>
        <Text fontSize="sm" color="gray.500" flex="1" mb={4}>
          {product.description}
        </Text>
        <Flex justify="space-between" align="center">
          <Text
            fontWeight="bold"
            fontSize="xl"
            color="brand.main"
          >
            {product.price}
          </Text>
          <Button
            as="span"
            size="sm"
            colorScheme="brand"
            bgColor="brand.main"
            color="white"
            _hover={{ bgColor: "brand.400" }}
            pointerEvents="none"
          >
            Voir le produit
          </Button>
        </Flex>
       </Flex>
    </Box>
    </NextLink>
  );
}

export default function ShopPage() {
  return (
    <PageLayout>
      <Head>
        <title>Boutique — Tête en l'Air</title>
        <meta
          name="description"
          content="Retrouvez tous les produits Tête en l'Air : flammes brodées, stickers et bundles."
        />
      </Head>

      <Box pt={16} pb={20}>
        <Heading color="secondary.main" mb={2}>
          Boutique
        </Heading>
        <Divider mb={6} />

        <Flex
          align="center"
          gap={2}
          color="brand.main"
          fontWeight="bold"
          fontSize="sm"
          mb={8}
        >
          <Icon as={Truck} boxSize={4} />
          <Text>Livraison offerte en France Métropolitaine, peu importe la quantité !</Text>
        </Flex>

        <SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} spacing={6}>
          {PRODUCTS.map((product) => (
            <ProductCard key={product.slug} product={product} />
          ))}
        </SimpleGrid>
      </Box>
    </PageLayout>
  );
}

export { PRODUCTS };